import styled from 'styled-components'

const CheckBoxInputSet = styled.li`
  padding: 7.5px 0;
  position: relative;
`

export default CheckBoxInputSet
